var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.viewLayout,{tag:"Component",scopedSlots:_vm._u([{key:"page-heading",fn:function(){return [_c('h1',{staticClass:"heading heading--large"},[_vm._v(" Minha conta ")])]},proxy:true},{key:"main",fn:function(){return [_c('div',{staticClass:"my-account"},[_c('WidgetAccount')],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }